import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersContactList() {
  // Use toast
  const toast = useToast()

  const refUsersContactListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'user_id', label: 'ID', sortable: true },
    { key: 'short_name', label: 'First Name', sortable: true },
    { key: 'family_name', label: 'Family Name', sortable: true },
    { key: 'slug', sortable: true },
    { key: 'email', sortable: true },
    { key: 'mobile', sortable: true },
    { key: 'wechat', sortable: true },
    { key: 'line', sortable: true },
    { key: 'whatsapp', sortable: true },
    { key: 'actions' },
  ]
  const usersContactList = ref(null)
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('user_id')
  const isSortDirDesc = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refUsersContactListTable.value ? refUsersContactListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  // const refetchData = () => {
  //   refUsersContactListTable.value.refresh()
  // }

  watch([currentPage, perPage, searchQuery], () => {
    // refetchData()
  })

  //table items provider
  const fetchUsersContact = (ctx, callback) => {
    store
      .dispatch('app-user/fetchUsersContact')
      .then(response => {
        const { contacts } = response.data
        const modifiedUsers = contacts.map(contact => ({
          ...contact, 
        }))
        usersContactList.value = modifiedUsers
        totalUsers.value = contacts.length
        // callback(users)
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'Supplier') return 'primary'
    if (role === 'Buyer') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchUsersContact,
    usersContactList,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUsersContactListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    // refetchData,

  }
}
